import type { UsaProps } from '@pages/Usa/UsaPage';

export const useReactData = (): UsaProps | null => {
  const root = document.querySelector('[data-react-data]') as HTMLElement;
  const attr = root?.getAttribute('data-react-data');
  return attr ? JSON.parse(attr) : null;
};
